import React from 'react'
import { useTranslation } from '@utils/i18n/i18n.consumers';

import './screen-not-supported.styl'

function ScreenNotSupported() {
  const { t } = useTranslation(); 
  return (
    <div className="screen-not-supported">
      <p>{t('This site is not optimized for your current screen size. Please use a larger device for the best experience.')}</p>
    </div>
  )
}

export default ScreenNotSupported